

export class PaystackPayment {
    private _id: number
    private _reference: string
    private _order_ref: string
    private _amount: number
    private _paid_at: Date
    private _created_at: Date


    constructor() {
        this._id = 0
        this._reference = ""
        this._order_ref = ""
        this._amount = 0
        this._paid_at = new Date();
        this._created_at = new Date();
    }


    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get reference(): string {
        return this._reference;
    }

    set reference(value: string) {
        this._reference = value;
    }

    get order_ref(): string {
        return this._order_ref;
    }

    set order_ref(value: string) {
        this._order_ref = value;
    }

    get amount(): number {
        return this._amount;
    }

    set amount(value: number) {
        this._amount = value;
    }

    get paid_at(): Date {
        return this._paid_at;
    }

    set paid_at(value: Date) {
        this._paid_at = value;
    }

    get created_at(): Date {
        return this._created_at;
    }

    set created_at(value: Date) {
        this._created_at = value;
    }
}




